export default function Input({
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  disabled = false,
  error,
  label,
  hint,
  required = false,
  autoFocus = false,
  id,
  readOnly,
  style,
  ...rest
}) {
  const fieldId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined)

  return (
    <div className={`tg-field${error ? ' tg-field--error' : ''}`}>
      {label && (
        <label className="tg-label" htmlFor={fieldId}>
          {label}{required && <span aria-hidden="true" style={{ color: 'var(--tg-status-danger)', marginLeft: 2 }}>*</span>}
        </label>
      )}
      <input
        id={fieldId}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoFocus={autoFocus}
        readOnly={readOnly}
        className={`tg-input${error ? ' is-error' : ''}`}
        style={style}
        {...rest}
      />
      {hint && !error && <span className="tg-help">{hint}</span>}
      {error && (
        <span className="tg-error">{error}</span>
      )}
    </div>
  )
}
